import "./App.scss";
function Pfooter() {
  return (
    <>
      <div className="P_footer">
        <p>
          By Reliable Software, Goa.{" "}
          <span className="white">Ph: 07969668000</span>{" "}
        </p>
      </div>
    </>
  );
}

export default Pfooter;
